import React from 'react';
import {
  ExtendedContentContainer,
  ExtendedContentType
} from 'components/ExtendedContent/ExtendedContentContainer';
import Translation from 'components/Translation';

export const TranslationModalComponent = ({ TranslationResource, shouldSplited = false }) => {
  return (
    <ExtendedContentContainer
      extendedContentType={ExtendedContentType.Translation}
      shouldSplited={shouldSplited}
    >
      <Translation data={TranslationResource} shouldSplited={shouldSplited} />
    </ExtendedContentContainer>
  );
};
